import { render, staticRenderFns } from "./VpnWarningPopup.vue?vue&type=template&id=d8728ece&scoped=true&"
import script from "./VpnWarningPopup.vue?vue&type=script&lang=js&"
export * from "./VpnWarningPopup.vue?vue&type=script&lang=js&"
import style0 from "./VpnWarningPopup.vue?vue&type=style&index=0&id=d8728ece&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8728ece",
  null
  
)

export default component.exports